import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';

import { Ehr } from '@patient/store/ehr/Ehr';
import { ProfileForm } from '@profile/store/ProfileForm';

import { ContactPersonCard, ContactPersonCardParams } from './ContactPersonCard';

interface Props extends ContactPersonCardParams {
    id: string;
    onUpdateContactPerson(): void;
}

interface StoreProps {
    ehr: Ehr;
    profileForm: ProfileForm;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const { profileForm, id } = this.props;

        const contactPerson = profileForm.getContactPerson(id);

        return React.createElement(ContactPersonCard, {
            // ...contactPerson.serialize(),
            firstName: contactPerson.firstName,
            isFirstNameValid: contactPerson.isFieldValid('firstName'),
            lastName: contactPerson.lastName,
            isLastNameValid: contactPerson.isFieldValid('lastName'),
            patronymic: contactPerson.patronymic,
            isPatronymicValid: contactPerson.isFieldValid('patronymic'),
            phone: contactPerson.phone,
            isPhoneValid: contactPerson.isFieldValid('phone'),
            onInputBlur: this.handleInputBlur,
            onInputChange: this.handleInputChange,
            onRemoveClick: this.handleRemoveContactPersons,
            onCountryChange: this.handleCountryChange,
        });
    }

    @autobind
    protected async handleInputBlur({ target: { name, value } }: React.FocusEvent<HTMLInputElement>) {}

    @autobind
    protected async handleInputChange(value: string, name: string) {
        await this.updateFieldValue(name, value);
    }

    @autobind
    protected async handleRemoveContactPersons() {
        const { profileForm, id, onUpdateContactPerson } = this.props;

        profileForm.removeContactPersonById(id);

        await onUpdateContactPerson();
    }

    @autobind
    protected async handleCountryChange(newPhone: string) {
        await this.updateFieldValue('phone', newPhone);
    }

    private async updateFieldValue(name: string, value: string) {
        const { profileForm, id, onUpdateContactPerson } = this.props;

        const contactPerson = profileForm.getContactPerson(id);
        contactPerson.setFieldValue(name, value);

        if (contactPerson.isFieldValid(name)) {
            await onUpdateContactPerson();
        }
    }
}

export const ContactPersonCardContainer = inject<Props, StoreProps>(Ehr.Name, ProfileForm.Name)(Component);
